import { listFileNamesFromS3, listFoldersFromS3 } from "../config/aws";
import { USER_NAME } from "../constant";
import { readFileFromS3, generatePresignedUrl, moveS3Folder } from "../config/aws";
import { API_SERVER_URL } from "../constant";
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { decreaseCredits, checkAvailableCredits } from '../dbApiFunctions';
import { showSuccessAlert, showErrorAlert, showWarningAlert, showInfoAlert, showConfirmDialog } from './sweetAlertConfig';

export const sendToBackend = async (endPoint, jsonData, credit, setCreditsAvailable) => {
    // console.log("sendToBackend = jsonData = ", jsonData)
    
    let API_SERVER_URL2 = API_SERVER_URL;
    let useCase = endPoint;
    if (endPoint === 'create') {     
        if (jsonData.backdropOnly) {
            API_SERVER_URL2 =  `https://quicsnap--mode-1-new-free-x4-model-inference.modal.run` 
        }
        else if (jsonData.reLight ) {
            API_SERVER_URL2 =  `https://quicsnap--mode-2-new-free-x4-model-inference.modal.run`
        }else {
            API_SERVER_URL2 = `https://quicsnap--no-mode-free-x4-model-inference.modal.run`
        }       
        endPoint = ""
        
    }
    else if (endPoint === 'upscale') {
        API_SERVER_URL2 = `https://quicsnap--upscaler-free-x4-model-inference.modal.run`
        endPoint = ""
    }
    else if (endPoint === 'edit') {
        API_SERVER_URL2 =  jsonData.prompt !== '' 
            ? `https://quicsnap--edit-new-free-x4-model-inference.modal.run` 
            : `https://quicsnap--edit-2-new-free-x4-model-inference.modal.run`
        endPoint = ""
    }
    else if (endPoint === 'create-checkout-session') {
        API_SERVER_URL2 = `https://quicsnap--stripe-free-x4-model-all-functions.modal.run`
        endPoint = "/create-checkout-session"
    }
    else {
        endPoint = `/${endPoint}`
    }

   
    const email = sessionStorage.getItem("email");
    const password = sessionStorage.getItem("password");

    const creditStatus = await checkAvailableCredits(email, password, credit);
    if (!creditStatus.status) {
        // alert(creditStatus.message);
        showErrorAlert(creditStatus.message);
        return;
    }

    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    const idToken = await user.getIdToken();
    // console.log("[ before backend call ]  user auth for backgroung check successful ")

    const formData = new FormData()
    // Add JSON data to FormData
    for (const key in jsonData) {
        if (jsonData.hasOwnProperty(key)) {
            formData.append(key, jsonData[key]);
        }
    }
    // console.log(`calling Backend API_SERVER_URL2=${API_SERVER_URL2}/${endPoint} jsonData=${JSON.stringify(jsonData)}`)

    return fetch(`${API_SERVER_URL2}${endPoint}`, {
        method: 'POST',
        headers: {
            'ngrok-skip-browser-warning': '69420',
            'Authorization': `Bearer ${idToken}`,
        },
        body: formData,
    }).then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    }).then(async (data) => {
        // console.log('Success:', data);
        const creditStatus = await decreaseCredits(email, password, credit, useCase);
        if (!creditStatus.status) {
            throw new Error(creditStatus.message);
        }
        // Update the credits available in the UI if setCreditsAvailable is provided
        if (setCreditsAvailable && typeof setCreditsAvailable === 'function') {
            setCreditsAvailable(creditStatus.credits);
        }
        return data;
    }).catch((error) => {
        console.error('Error:', error);
        throw error;
    });
}

export const downloadImage = (canvasRef, downloadImageName) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const image = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = image;
    link.download = downloadImageName;
    link.click();
};

export const downloadImage2 = (canvasRef, downloadImageName) => {
    return new Promise((resolve, reject) => {
        try {
            const canvas = canvasRef.current;
            if (!canvas) {
                reject(new Error('Canvas reference is not available'));
                return;
            }

            // Try to get the image data with preserveDrawingBuffer
            const context = canvas.getContext('2d', { preserveDrawingBuffer: true });
            const dataUrl = canvas.toDataURL('image/png', 1.0);

            // Create a new canvas to ensure we get a clean copy
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            const tempCtx = tempCanvas.getContext('2d');

            // Copy the original canvas content
            tempCtx.drawImage(canvas, 0, 0);

            // Get the data URL from the temporary canvas
            const finalDataUrl = tempCanvas.toDataURL('image/png', 1.0);

            const link = document.createElement('a');
            link.href = finalDataUrl;
            link.download = downloadImageName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up
            tempCanvas.remove();
            resolve();
        } catch (error) {
            console.error('Error in downloadImage:', error);
            reject(error);
        }
    });
};
const historyLength = 10;
export const fetchAllEditHistory = async (allEditHistory, setAllEditHistory, pageNumber) => {
    const basePath = `USERS/${USER_NAME}/all_editPage/`;
    let timestamps = await listFoldersFromS3(basePath);
    // console.log("total Edit entries = ", timestamps.length)
    timestamps.sort().reverse();

    // Only slice if there are more than 20 timestamps
    // If there are more than 25 timestamps, move older entries to an archive folder
    if (timestamps.length > 900) {
        const foldersToArchive = timestamps.slice(800);
        for (const folder of foldersToArchive) {
            const sourcePath = `${basePath}${folder}/`;
            const destinationPath = `USERS/${USER_NAME}/RecycleBin/all_editPage/${folder}/`;
            
            try {
                // Move the folder to archive location
                moveS3Folder(sourcePath, destinationPath);
                // console.log(`Successfully archived edit history: ${folder}`);
            } catch (error) {
                console.error(`Error archiving edit history ${folder}:`, error);
            }
        }
        
        // Keep only the first 20 timestamps after archiving
        timestamps = timestamps.slice(0, 800);
    }

    timestamps = timestamps.slice(pageNumber * historyLength, (pageNumber + 1) * historyLength);
    const editHistory = [];
    for (const timestamp of timestamps) {
        const lowQualityPath = `${basePath}${timestamp}/outputFolder/lowQuality/`;
        const allImages = await listFileNamesFromS3(lowQualityPath);
        if (allImages.length === 0) {
            continue;
        }
        const metadata = await readFileFromS3(`${basePath}${timestamp}/metadata.json`);
        let editEntry = { ...JSON.parse(metadata), images: [] };
        for (const image of allImages) {
            if (image.endsWith('/')) { continue; }
            const imageUrl = await generatePresignedUrl(image);
            editEntry.images.push({ src: imageUrl, alt: "" });
        }
        editHistory.push(editEntry);
    }
    setAllEditHistory(editHistory);
};

export const fetchAllCreateHistory = async (allCreateHistory, setAllCreateHistory, pageNumber, type) => {
    const basePath = `USERS/${USER_NAME}/${type}/`;
    let timestamps = await listFoldersFromS3(basePath);
    // console.log("total Create entries = ", timestamps.length)
    timestamps.sort().reverse();

    // If there are more than 25 timestamps, move older entries to an archive folder
    if (timestamps.length > 900) {
        const foldersToArchive = timestamps.slice(800);
        for (const folder of foldersToArchive) {
            const sourcePath = `${basePath}${folder}/`;
            const destinationPath = `USERS/${USER_NAME}/RecycleBin/${type}/${folder}/`;
            
            try {
                // Move the folder to archive location
                moveS3Folder(sourcePath, destinationPath);
                // console.log(`Successfully archived create history: ${folder}`);
            } catch (error) {
                console.error(`Error archiving create history ${folder}:`, error);
            }
        }
                // Keep only the first  timestamps after archiving
        timestamps = timestamps.slice(0, 800);
    }


    // Limit to first 20 timestamps for performance
    timestamps = timestamps.slice(pageNumber * historyLength, (pageNumber + 1) * historyLength);
    const createHistory = [];
    for (const timestamp of timestamps) {
        const allImages = await listFileNamesFromS3(`${basePath}${timestamp}/outputFolder/lowQuality/`);
        if (allImages.length === 0) {
            continue;
        }
        const metadata = await readFileFromS3(`${basePath}${timestamp}/metadata.json`);
        let createEntry = { ...JSON.parse(metadata), images: [] };
        for (const image of allImages) {
            if (image.endsWith('/')) { continue; }
            const imageUrl = await generatePresignedUrl(image);
            createEntry.images.push({ src: imageUrl, alt: "" });
        }
        createHistory.push(createEntry);
    }
    setAllCreateHistory(createHistory);
};

// export const sendToBackend2 = async (endPoint, jsonData, credit) => {
//     const formData = new FormData()
//     // Add JSON data to FormData
//     for (const key in jsonData) {
//         if (jsonData.hasOwnProperty(key)) {
//             formData.append(key, jsonData[key]);
//         }
//     }
//     return fetch(`${API_SERVER_URL}/${endPoint}`, {
//         method: 'POST',
//         headers: {
//             'ngrok-skip-browser-warning': '69420',
//         },
//         body: formData,
//     })
//         .then((response) => {
//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }
//             return response.json();
//         })
//         .then((data) => {
//             // console.log('Success:', data);
//             return data;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//             throw error;
//         });
// }


async function get_job_status(jobId) {
    const url = `${API_SERVER_URL}/status/${jobId}`;
    // console.log("checking status for " + url)
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        // console.log('Job Status:', data);
        return data;
    } catch (error) {
        console.error('Failed to fetch job status:', error);
        return null;
    }
}

export async function check_job_status(jobResponseCanvas) {
    let jobStatus = get_job_status(jobResponseCanvas['job_id']);
    if (jobStatus !== null) {
        switch (jobStatus['status']) {
            case 'completed':
                return 0;
            case 'failed': 
                // alert("Server Error : Create Image generation failed ❌");
                showErrorAlert('Create Image generation failed ❌');
                return 0; 
            case 'Job not found':
                // alert("Server Error : Job not found ❌");
                showErrorAlert('Job not found ❌');
                return 0;
            default:
                return 1;
        }
    }
}

export const hashString = async (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
};